// Novo arquivo para o componente dos termos
import { useTranslation } from 'react-i18next';

export const TermosPrivacidade = () => {
    const { t } = useTranslation('settings');

    return (
        <div class="max-w-3xl mx-auto p-6 bg-white mt-10">

        <section class="mb-6">
            <h2 class="text-xl font-semibold text-gray-700 mb-2">{t('integrations.termsPrivacy.permissions.title', '1. Permissões')}</h2>
            <ul class="list-disc list-inside text-gray-600">
                <li>{t('integrations.termsPrivacy.permissions.item1', 'Acessar seu calendário Google')}</li>
                <li>{t('integrations.termsPrivacy.permissions.item2', 'Visualizar eventos existentes')}</li>
                <li>{t('integrations.termsPrivacy.permissions.item3', 'Criar novos eventos em seu nome')}</li>
                <li>{t('integrations.termsPrivacy.permissions.item4', 'Atualizar eventos existentes')}</li>
                <li>{t('integrations.termsPrivacy.permissions.item5', 'Excluir eventos criados pela integração')}</li>
            </ul>
        </section>

        <section class="mb-6">
            <h2 class="text-xl font-semibold text-gray-700 mb-2">{t('integrations.termsPrivacy.dataUsage.title', '2. Uso dos Dados')}</h2>
            <ul class="list-disc list-inside text-gray-600">
                <li>{t('integrations.termsPrivacy.dataUsage.item1', 'Sincronização de agendamentos')}</li>
                <li>{t('integrations.termsPrivacy.dataUsage.item2', 'Gerenciamento de disponibilidade')}</li>
                <li>{t('integrations.termsPrivacy.dataUsage.item3', 'Notificações de compromissos')}</li>
                <li>{t('integrations.termsPrivacy.dataUsage.item4', 'Relatórios e análises de compromissos')}</li>
            </ul>
        </section>

        <section class="mb-6">
            <h2 class="text-xl font-semibold text-gray-700 mb-2">{t('integrations.termsPrivacy.security.title', '3. Segurança e Privacidade')}</h2>
            <ul class="list-disc list-inside text-gray-600">
                <li>{t('integrations.termsPrivacy.security.item1', 'Protegemos suas informações pessoais')}</li>
                <li>{t('integrations.termsPrivacy.security.item2', 'Não compartilhamos seus dados com terceiros')}</li>
                <li>{t('integrations.termsPrivacy.security.item3', 'Seus dados são mantidos seguros e criptografados')}</li>
                <li>{t('integrations.termsPrivacy.security.item4', 'Você pode revogar o acesso a qualquer momento')}</li>
            </ul>
        </section>

        <section class="mb-6">
            <h2 class="text-xl font-semibold text-gray-700 mb-2">{t('integrations.termsPrivacy.consent.title', '4. Consentimento e Controle do Usuário')}</h2>
            <ul class="list-disc list-inside text-gray-600">
                <li>{t('integrations.termsPrivacy.consent.item1', 'Ao conectar sua conta, você concorda com esses termos')}</li>
                <li>{t('integrations.termsPrivacy.consent.item2', 'Gerencie suas permissões no Google')}</li>
                <li>{t('integrations.termsPrivacy.consent.item3', 'Entre em contato conosco para suporte')}</li>
            </ul>
        </section>

    </div>
    );
};